import { render, staticRenderFns } from "./EventItemDetail_5.vue?vue&type=template&id=55c4cec6"
import script from "./EventItemDetail_5.vue?vue&type=script&lang=js"
export * from "./EventItemDetail_5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports